import { Link } from "react-router-dom";
import { specialList } from "@/mocks/specials";
import { getMediaById } from "@/lib/mediaQuery";
import { useSeo } from "@/hooks/useSeo";
import MediaCard from "@/components/feature/MediaCard";

export default function SpecialPage() {
  useSeo({
    title: "影视专题合集 - 缘之空影视资讯平台",
    description:
      "缘之空影视专题合集，围绕年代叙事、科幻宇宙、悬疑推理与世界影坛等主题精心策划，帮你成体系地发现值得一看的影视作品。",
    keywords: "缘之空,影视专题,影视合集,主题推荐,影视资讯,剧情介绍",
  });

  if (specialList.length === 0) {
    return (
      <div className="w-full px-4 md:px-6 py-20 flex flex-col items-center text-center">
        <span className="w-16 h-16 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center mb-4">
          <i className="ri-inbox-line text-3xl"></i>
        </span>
        <h1 className="font-heading text-xl font-bold text-foreground-950 mb-2">专题内容暂未上线</h1>
        <p className="text-sm text-foreground-500 mb-6">我们正在筹备更多影视专题，欢迎先返回首页浏览。</p>
        <Link to="/" className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors">
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
      </div>
    );
  }

  const hero = specialList[0];

  return (
    <div className="w-full">
      <section className="relative w-full h-[280px] md:h-[360px] overflow-hidden bg-primary-950">
        <img src={hero.cover} alt={`${hero.title} 影视专题主视图`} title={hero.title} className="absolute inset-0 w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/50 to-primary-950/40"></div>
        <div className="absolute inset-0 flex items-center">
          <div className="w-full px-4 md:px-6">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-foreground-950 text-xs font-bold mb-4">
              <i className="ri-bookmark-3-line"></i>
              影视专题
            </span>
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-3">{hero.title}</h1>
            <p className="text-sm md:text-base text-background-100/85 max-w-2xl leading-relaxed">{hero.intro}</p>
          </div>
        </div>
      </section>

      <div className="w-full px-4 md:px-6 py-8 md:py-10">
        <nav className="flex flex-wrap gap-2 mb-10">
          {specialList.map((sp) => (
            <a
              key={sp.id}
              href={`#${sp.id}`}
              className="px-4 py-2 rounded-md bg-background-100 text-foreground-700 text-sm hover:bg-primary-50 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              {sp.title}
            </a>
          ))}
        </nav>

        <div className="space-y-14 md:space-y-16">
          {specialList.map((sp) => (
            <section key={sp.id} id={sp.id} className="scroll-mt-24">
              <div className="flex flex-col md:flex-row md:items-end gap-4 mb-6">
                <div className="flex-1">
                  <span className="inline-flex items-center gap-1.5 text-xs font-label font-semibold text-accent-700 mb-2">
                    <span className="w-4 h-0.5 bg-accent-500 rounded-full"></span>
                    {sp.subtitle}
                  </span>
                  <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">{sp.title}</h2>
                  <p className="mt-2 text-sm text-foreground-600 max-w-3xl leading-relaxed">{sp.intro}</p>
                </div>
              </div>

              <div className="space-y-8">
                {sp.groups.map((group) => {
                  const media = group.mediaIds.map((mid) => getMediaById(mid)).filter(Boolean);
                  if (media.length === 0) return null;
                  return (
                    <div key={group.name}>
                      <h3 className="text-sm font-bold text-foreground-800 mb-4 flex items-center gap-2">
                        <i className="ri-folder-open-line text-primary-500"></i>
                        {group.name}
                        <span className="text-xs font-normal text-foreground-400">（{media.length} 部）</span>
                      </h3>
                      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
                        {media.map((m, i) => m && <MediaCard key={m.id} item={m} index={i} />)}
                      </div>
                    </div>
                  );
                })}
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}